import {
  SET_MISSIONS_MONITORING,
  SET_MISSIONS_MONITORING_LOADING,
} from "./actionTypes";

import { hasMonitoringRole } from "../users/rolesUtil";
import { requestFetchMissionsMonitoring } from "../services/backendRequests";

export async function fetchMissionsMonitoring(contractUuids, user) {
  if (contractUuids.length === 0) return [];
  const baseMissionMonitorings = await requestFetchMissionsMonitoring(
    contractUuids,
    user
  );

  return baseMissionMonitorings.map((missionMonitoring) => {
    return {
      ...missionMonitoring,
      groups: {
        campaign: missionMonitoring.contract_info.id,
        country: missionMonitoring.site.country,
        crop: missionMonitoring.crop,
        sensor_type: missionMonitoring.sensor_type,
        ...missionMonitoring.custom_data,
      },
    };
  });
}

// Cache-first thunk: fetch a campaign's mission monitoring once and reuse it
// across the campaign page and its site pages (keyed by campaignId in the
// store). `force` refetches even when cached; `silent` keeps the current data
// visible (no loading flip) — used to refresh in place after a flag/comment.
export const loadMissionsMonitoring =
  (campaignId, { force = false, silent = false } = {}) =>
  async (dispatch, getState) => {
    if (!campaignId) return;
    const { user, missionMonitoring } = getState();
    const contract = user.contracts?.find((c) => c.id === campaignId);
    // Contract not found means user.contracts isn't loaded yet (both call sites
    // re-dispatch when it lands). Do NOT cache [] here: an empty array is truthy
    // and would satisfy the guard below, locking out the real fetch forever.
    if (!contract) return;
    // Contract present but without the monitoring role — permanently no data,
    // safe to cache.
    if (!hasMonitoringRole(contract.roles)) {
      dispatch({ type: SET_MISSIONS_MONITORING, campaignId, missions: [] });
      return;
    }
    if (missionMonitoring.byCampaign[campaignId] && !force) return;
    if (!silent)
      dispatch({
        type: SET_MISSIONS_MONITORING_LOADING,
        campaignId,
        loading: true,
      });
    try {
      const missions = await fetchMissionsMonitoring([campaignId], user);
      dispatch({ type: SET_MISSIONS_MONITORING, campaignId, missions });
    } catch {
      // keep any previously cached data on failure
    } finally {
      if (!silent)
        dispatch({
          type: SET_MISSIONS_MONITORING_LOADING,
          campaignId,
          loading: false,
        });
    }
  };
